import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { NeproseService } from 'src/app/services/neprose.service';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  userProfile: any
  
  selectedImage: any

  url: any

  constructor(private _auth: AuthService, private _neproseService: NeproseService, private notification: MatSnackBar) {
    this._auth.getLoggedIn.subscribe(data => {
      if(data == 'loggedIn'){
        this.loggedIn()
      }else if(data == 'loggedOut'){
        this.loggedOut()
      } 
    })
  }

  loggedInStatus: boolean = false;

  ngOnInit(): void {
    if(this._auth.accessToken){
      this.getProfileInfo()
    }
  }

  loggedIn(){
    this.getProfileInfo()
  }

  getProfileInfo(){
    this._neproseService.getUserProfile().subscribe(data => {
      if(data.status){
        this.userProfile = data.user
        this.loggedInStatus = true;
        if(this.userProfile.profileImage){
          this.selectedImage = environment.api + '/images/' + this.userProfile.profileImage
        }else{
          this.selectedImage = null
        }
      }
    }, error => {
      if(error.status == 404){
        this._auth.clearStorage()
        this.openNotification('User does not exist!')
      }
    })
  }

  loggedOut(){
    this.loggedInStatus = false;
  }

  logOut(){
    this._auth.logOut().subscribe( data => {
        if(data.status){
          this._auth.clearStorage();
        }
      });
  }

  openNotification(msg){
    this.notification.open(msg, 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }

}
